<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">角色管理</div>
        <el-form
          class="zj-search-form"
          ref="queryForm"
          :model="queryParams"
          :label-width="labelWidth"
        >
          <el-form-item label="角色名称" prop="roleName">
            <el-input
              v-model="queryParams.roleName"
              placeholder="请输入角色名称"
            ></el-input>
          </el-form-item>

          <el-form-item label="角色权限" prop="roleKey">
            <el-input
              v-model="queryParams.roleKey"
              placeholder="请输入角色权限"
            ></el-input>
          </el-form-item>

          <el-form-item label="状态" prop="status">
            <el-select
              v-model="queryParams.status"
              placeholder="角色状态"
            >
              <el-option
                v-for="dict in dict.type.permission_status"
                :key="dict.value"
                :label="dict.label"
                :value="dict.value"
              />
            </el-select>
          </el-form-item>
          
          <el-form-item label class="right">
            <el-button @click="handleQuery">搜 索</el-button>
            <el-button @click="resetQuery">重 置</el-button>
            <el-button @click="handleAdd">新 增</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>

      <zj-layout-main>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table v-loading="loading" :data="roleList">      
            <el-table-column label="角色编号" prop="roleId" width="100" />
            <el-table-column label="角色名称" prop="roleName" width="150" />
            <el-table-column label="角色权限" prop="roleKey" width="150" />
            <el-table-column label="显示顺序" prop="roleSort" width="50" />
            <el-table-column label="状态" align="center" width="80">
              <template slot-scope="scope">
                <el-switch
                  v-model="scope.row.status"
                  active-value="0"
                  inactive-value="1"
                  @change="handleStatusChange(scope.row)"
                ></el-switch>      
              </template>
            </el-table-column>
            <el-table-column label="创建时间" align="center" prop="createTime">
              <template slot-scope="scope">
                <span>{{ parseTime(scope.row.createTime) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  icon="el-icon-edit-outline"
                  @click="handleUpdate(scope.row)"
                >修改</el-button>
                <el-button
                  type="text"
                  icon="el-icon-delete"
                  @click="handleDelete(scope.row)"
                >删除</el-button>
                <el-button
                  type="text"
                  icon="el-icon-user"
                  @click="handleAuthUser(scope.row)"
                >分配用户</el-button>
              </template>
            </el-table-column>
          </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryParams.pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="queryParams.pageSize"  
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>

    <!-- 添加或修改角色 -->
    <el-dialog :title="title" :visible.sync="open" width="550px" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="角色名称" prop="roleName">
          <el-input v-model="form.roleName" placeholder="请输入角色名称" />
        </el-form-item>
        <el-form-item label="角色权限" prop="roleKey">
          <el-input v-model="form.roleKey" placeholder="请输入角色权限" />
        </el-form-item>
        <el-form-item label="角色顺序" prop="roleSort">
          <el-input-number v-model="form.roleSort" controls-position="right" :min="0" />
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="form.status" style="margin-left: 5px;">
            <el-radio
              v-for="dict in dict.type.permission_status"
              :key="dict.value"
              :label="dict.value"
            >{{dict.label}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="菜单权限">
          <el-checkbox v-model="menuExpand" @change="handleCheckedTreeExpand" style="margin-left: 5px;">展开/折叠</el-checkbox>
          <el-checkbox v-model="menuNodeAll" @change="handleCheckedTreeNodeAll">全选/全不选</el-checkbox>
          <el-checkbox v-model="form.menuCheckStrictly" @change="handleCheckedTreeConnect">父子联动</el-checkbox>
          <!-- check-strictly: false父子关联、true父子不关联-->
          <el-tree
            :data="menuOptions"
            show-checkbox
            ref="menu"
            node-key="id"
            :check-strictly="!form.menuCheckStrictly"
            empty-text="加载中，请稍后"
            :props="defaultProps"
          ></el-tree>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.remark" type="textarea" placeholder="请输入内容"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listRole, getRoleById, addRole, updateRole, delRole, changeRoleStatus } from "@/api/system/permission/role";
import { menuTree, getMenuTreeByRole } from "@/api/system/permission/menu";
export default {
  name: "RoleView",
  controller: "UI",
  action: "RoleView",
  dicts: ['permission_status'],
  data() {
    return {
      // 遮罩层
      loading: true,
      // 总条数
      total: 0,
      // 角色表格数据
      roleList: [],
      // 查询参数
      queryParams: {
        roleName: null,
        roleKey: null,
        status: null,
        pageNum: 1,
        pageSize: 10,
      },
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 是否展开
      menuExpand: false,
      // 是否全选
      menuNodeAll: false,
      // 菜单列表
      menuOptions: [],
      // 配置项
      defaultProps: {
        children: "children",
        label: "label"
      },
      // 表单参数
      form: {},
      // 表单校验
      rules: {
        roleName: [
          { required: true, message: "角色名称不能为空", trigger: "blur" },
          { max: 15, message: "角色名称长度在15个字符内", trigger: "blur" },
          { pattern: '[^ \x22]+', message: "角色名称不能为空", trigger: "blur" }
        ],
        roleKey: [
          { required: true, message: "角色权限不能为空", trigger: "blur" }
        ],
        roleSort: [
          { required: true, message: "角色顺序不能为空", trigger: "blur" }
        ]
      }
    };
  },
  created() {
    this.getList();
    this.logInfo.ActionName = "角色管理查看";
    this.logInfo.LogMessage = "角色管理查看";
    this.logInfo.ModuleName = "账号管理";
    this.logInfo.PageName = "角色管理列表页面";
    this.addOperationLog();
    this.getMenuTreeselect();
  },
  methods: {
    // 查询角色列表
    getList() {
      this.loading = true;
      listRole(this.queryParams).then(response => {
          response.rows.forEach(item=>{
            item.status = String(item.status)
          })
          this.roleList = response.rows;
          this.total = parseInt(response.total);
          this.loading = false;
          // console.log("this.roleList")
          // console.log(this.roleList)
        }
      );
    },
    // 查询菜单树
    getMenuTreeselect() {
      menuTree().then(response => {
        this.menuOptions = response.data;
      });
    },
    // 搜索
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    // 重置
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },
    // 新增
    handleAdd() {
      this.reset();
      this.open = true;
      this.title = "添加角色";
    },

    // 角色状态修改
    handleStatusChange(row) {
      let text = row.status == "0" ? "启用" : "停用";
      this.$confirm('确认要"' + text + '""' + row.roleName + '"角色吗？').then(function() {
        return changeRoleStatus({roleId: row.roleId, status: row.status});
      }).then(() => {
        this.$message({type: "success", message: text + "成功"});
      }).catch(() => {});
    },
    // 行修改
    handleUpdate(row) {
      this.reset();
      getRoleById(row.roleId).then(response => {
        this.form = response.data;
        this.open = true;
        this.$nextTick(() => {
          getMenuTreeByRole(row.roleId).then(response => {
            let checkedKeys = response.data.checkedKeys;  //拿到选中数组
            checkedKeys.forEach((v) => {
              this.$nextTick(()=>{
                  this.$refs.menu.setChecked(v, true ,false);  //设置节点的勾选状态
              })
            })
          });
        });
        this.title = "修改角色";
      });
    },
    // 行删除
    handleDelete(row) {
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(function() {
        return delRole(row.roleId);
      }).then(() => {
        this.$message({type: "success", message: "删除成功!"});
        this.logInfo.ActionName = "角色删除";
        this.logInfo.LogMessage = "角色删除成功";
        this.logInfo.ModuleName = "账号管理";
        this.logInfo.PageName = "角色管理列表页面";
        this.addOperationLog();
        this.getList();
      }).catch(() => {});
    },
    // 分配用户
    handleAuthUser(row) {
      this.$router.push({path: '/plugin/permission/UI/RoleUserView', query: { roleId: row.roleId }})
    },
    
    // 表单重置
    reset() {
      if (this.$refs.menu != null) {
        this.$refs.menu.setCheckedKeys([]);  //设置目前勾选的节点
      }
      this.menuExpand = false,
      this.menuNodeAll = false,
      this.form = {
        roleId: null,
        roleName: null,
        roleKey: null,
        roleSort: 0,
        status: "0",
        menuCheckStrictly: true,  //true为父子关联
        menuIds: [],  //保存选中节点
        remark: null,
      };
      this.resetForm("form");
    },
    // 菜单选中节点
    getMenuAllCheckedKeys() {
      // 目前被选中的菜单节点
      let checkedKeys = this.$refs.menu.getCheckedKeys();  //目前被选中的节点数组
      // 半选中的菜单节点
      let halfCheckedKeys = this.$refs.menu.getHalfCheckedKeys();
      checkedKeys.unshift.apply(checkedKeys, halfCheckedKeys);
      return checkedKeys;
    },
    // 提交
    submitForm: function() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.form.roleId != null) {
            this.form.menuIds = this.getMenuAllCheckedKeys();
            updateRole(this.form).then(response => {
              this.$message({type: "success", message: "修改成功"});
              this.logInfo.ActionName = "角色修改";
              this.logInfo.LogMessage = "角色修改成功";
              this.logInfo.ModuleName = "账号管理";
              this.logInfo.PageName = "角色管理列表页面";
              this.addOperationLog();
              this.open = false;
              this.getList();
            });
          } else {
            this.form.menuIds = this.getMenuAllCheckedKeys();
            addRole(this.form).then(response => {
              this.$message({type: "success", message: "新增成功"});
              this.logInfo.ActionName = "角色添加";
              this.logInfo.LogMessage = "角色添加成功";
              this.logInfo.ModuleName = "账号管理";
              this.logInfo.PageName = "角色管理列表页面";
              this.addOperationLog();
              this.open = false;
              this.getList();
            });
          }
        }
      });
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 树权限（展开/折叠）
    handleCheckedTreeExpand(value) {
      let treeList = this.menuOptions;
      for (let i = 0; i < treeList.length; i++) {
        this.$refs.menu.store.nodesMap[treeList[i].id].expanded = value;
      }
    },
    // 树权限（全选/全不选）
    handleCheckedTreeNodeAll(value) {
      this.$refs.menu.setCheckedNodes(value ? this.menuOptions: []);
    },
    // 树权限（父子联动）
    handleCheckedTreeConnect(value) {
      this.form.menuCheckStrictly = value ? true: false;
    }, 

    // 点击每页显示的条数
    handleSizeChange(val){
      this.queryParams.pageSize = val;
      this.getList();
    },
    // 点击切换到某页
    handleCurrentChange(val){
      this.queryParams.pageNum = val;
      this.getList();
    }
  }
};
</script>
<style scoped>
::v-deep .el-form-item__content{
  text-align: left;
}
</style>